import { createSlice } from '@reduxjs/toolkit';

export const OBJECT_ERASE_USE_CREDIT = 5;

export const FJSliceObjectErase = createSlice({
    name: 'objectErase',
    initialState: {
        inputImageInfo: null,

        textEraseInputImageInfo: {},

        curMenuIndex: 0,

        textPrompt: '',
    },
    reducers: {
        setSliceInputImageInfo: (state, action) => {
            state.inputImageInfo = action.payload;
        },
        setSliceCurMenuIndex: (state, action) => {
            state.curMenuIndex = action.payload;
        },
        setSliceTextPrompt: (state, action) => {
            state.textPrompt = action.payload;
        },
        setSliceTextEraseInputImageInfo: (state, action) => {
            state.textEraseInputImageInfo = action.payload;
        },
    },
});

export const { setSliceInputImageInfo, setSliceCurMenuIndex, setSliceTextPrompt, setSliceTextEraseInputImageInfo } =
    FJSliceObjectErase.actions;

export default FJSliceObjectErase.reducer;
